webpackJsonp([35783957827783],{

/***/ 330:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyPluginPageTransitions = __webpack_require__(35);
	
	var _gatsbyPluginPageTransitions2 = _interopRequireDefault(_gatsbyPluginPageTransitions);
	
	__webpack_require__(330);
	
	var _components = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    _gatsbyPluginPageTransitions2.default,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'index-measurements-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: '' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement('div', { className: 'col-lg-4 offset-lg-8 col-md-4 offset-md-8 index-measurement-background' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(_components.Measurements, null)
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container index-founded-wrapper' },
	      _react2.default.createElement(_components.Founded, null)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container index-services-wrapper' },
	      _react2.default.createElement(_components.Services, null)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container index-accreditation-wrapper' },
	      _react2.default.createElement(_components.Accreditation, null)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container index-automatization-wrapper' },
	      _react2.default.createElement(_components.Automatization, null)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'index-references-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(_components.References, null)
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'index-first-link' },
	      _react2.default.createElement(_components.BigLink, {
	        to: '/proizvodi',
	        title: 'Proizvodi',
	        subtitle: 'Pogledajte \u0161to nudimo'
	      })
	    ),
	    _react2.default.createElement(_components.BigLink, { to: '/kontakt', title: 'Javite se', subtitle: 'Znate \u0161to \u017Eelite' })
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-de70963611cb7bd711d9.js